import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FixedTooltip from 'dpl/common/tooltip/components/FixedTooltip';

const PORTAL_MOUNT_EL = window.document.body;

/** @param {any} props */
export default function StripeChargeModalFixedTooltipWrapper({
  title,
  children,
  className = null,
  isVisible,
  onCloseTooltipClick,
  onClick
}) {
  useEffect(() => {
    isVisible
      ? PORTAL_MOUNT_EL.classList.add('no-scroll')
      : PORTAL_MOUNT_EL.classList.remove('no-scroll');
  }, [isVisible]);

  return (
    <div
      className={classnames(
        'StripeChargeModalFixedTooltipWrapper dib',
        className
      )}
    >
      <div
        role="button"
        tabIndex="0"
        onKeyPress={null}
        onClick={e => {
          e.preventDefault();
          onClick();
        }}
        className="pointer"
      >
        {children}
      </div>
      {createPortal(
        <>
          {isVisible && (
            <div
              role="button"
              tabIndex="-1"
              onKeyPress={null}
              onClick={onCloseTooltipClick}
              className="fixed bg-black-70 absolute--fill z-max"
            />
          )}
          <div
            data-test-id="tooltip"
            className={classnames(
              'FixedTooltipWrapper__tooltip z-max fixed transition bottom-0 left-0 right-0',
              {
                'FixedTooltipWrapper__tooltip--hidden': !isVisible
              }
            )}
          >
            <FixedTooltip title={title} onCloseClick={onCloseTooltipClick} />
          </div>
        </>,
        PORTAL_MOUNT_EL
      )}
    </div>
  );
}

StripeChargeModalFixedTooltipWrapper.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  onCloseTooltipClick: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
};
